export function resolveAppOrigin(
  browserOrigin: string | undefined,
  configuredAppUrl: string | undefined,
): string {
  if (browserOrigin) return new URL(browserOrigin).origin;
  if (configuredAppUrl) return new URL(configuredAppUrl).origin;

  throw new Error("APP_URL is required");
}
